import '@styles/global.css';
import '@utils/i18n';
import ReactDOM from 'react-dom/client';
import App from './App';
import { persistor, store } from '@store/index';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import AppErrorBoundary from '@components/ErrorBoundary';

// Initialize Sentry only for production
if (
  import.meta.env.VITE_APP_ENV === 'production' &&
  import.meta.env.VITE_PUBLIC_SENTRY_DSN
) {
  Sentry.init({
    dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_APP_VERSION || '1.0.0',
    dist:
      import.meta.env.VITE_APP_ENV === 'production' ? 'production' : 'sandbox',
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </AppErrorBoundary>,
);
